module.exports = __webpack_public_path__ + "img/wechat.40041dab.jpg";